if (!customElements.get("blaze-announcement-bar")) {
  customElements.define(
    "blaze-announcement-bar",
    class BlazeAnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.currentSlideIndex = 0;
        this.initializationAttempts = 0;
        this.maxAttempts = 10;
        this.autoplayTimer = null;
        this.autoplayDelay = 5000;
        this.enableAutoplay = true;
      }

      connectedCallback() {
        this.initializeBlazeSlider();
      }

      disconnectedCallback() {
        this.clearAutoplayTimer();
      }

      initializeBlazeSlider() {
        const sliderElement = this.querySelector(".blaze-slider");
        if (!sliderElement) {
          return;
        }

        const slides = sliderElement.querySelectorAll(".blaze-slide");

        // If only one slide, no need for slider functionality
        if (slides.length <= 1) {
          return;
        }

        // Check if BlazeSlider is available
        if (typeof window.BlazeSlider === "undefined") {
          this.initializationAttempts++;

          if (this.initializationAttempts < this.maxAttempts) {
            setTimeout(() => this.initializeBlazeSlider(), 200);
          }
          return;
        }

        // Get autoplay settings
        this.autoplayDelay = parseInt(this.getAttribute("data-delay") || 5000);
        this.enableAutoplay = this.getAttribute("data-autoplay") !== "false";

        try {
          // Initialize Blaze Slider
          const blazeSlider = new window.BlazeSlider(sliderElement, {
            all: {
              enableAutoplay: false,
              enablePagination: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              transitionDuration: 300,
              transitionTimingFunction: "ease-in-out",
              loop: true,
              draggable: true,
            },
          });

          this.blazeSlider = blazeSlider;

          // Set up navigation buttons
          this.setupNavigation();

          // Handle slide change events
          blazeSlider.onSlide((pageIndex) => {
            this.currentSlideIndex = pageIndex;
            this.resetAutoplayTimer();
          });

          // Start autoplay
          if (this.enableAutoplay) {
            this.startAutoplayTimer();
          }
        } catch (error) {
          console.error(
            "Error initializing BlazeSlider for announcement bar:",
            error
          );
        }
      }

      setupNavigation() {
        const prevButton = this.querySelector(".announcement-bar__nav--prev");
        const nextButton = this.querySelector(".announcement-bar__nav--next");

        if (prevButton) {
          prevButton.addEventListener("click", () => {
            if (this.blazeSlider) {
              this.blazeSlider.prev();
              this.resetAutoplayTimer();
            }
          });
        }

        if (nextButton) {
          nextButton.addEventListener("click", () => {
            if (this.blazeSlider) {
              this.blazeSlider.next();
              this.resetAutoplayTimer();
            }
          });
        }
      }

      startAutoplayTimer() {
        if (!this.enableAutoplay) return;

        this.clearAutoplayTimer();

        this.autoplayTimer = setTimeout(() => {
          if (this.blazeSlider) {
            this.blazeSlider.next();
            this.startAutoplayTimer();
          }
        }, this.autoplayDelay);
      }

      resetAutoplayTimer() {
        if (!this.enableAutoplay) return;
        this.startAutoplayTimer();
      }

      clearAutoplayTimer() {
        if (this.autoplayTimer) {
          clearTimeout(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      activeMedia(index) {
        if (this.blazeSlider) {
          const difference = index - this.currentSlideIndex;
          if (difference > 0) {
            this.blazeSlider.next(difference);
          } else if (difference < 0) {
            this.blazeSlider.prev(Math.abs(difference));
          }
        }
      }
    }
  );
}
